import {useIntl} from 'react-intl'
import {useBrand} from '../../contexts/brand-context'

export default function useGiftCardFields({
    form: {
        control,
        formState: {errors},
        watch
    },
    prefix = ''
}) {
    const {formatMessage} = useIntl()
    const {isGarage} = useBrand

    const recipientEmail = watch(`${prefix}recipientEmail`)

    const fields = {
        yourName: {
            name: `${prefix}yourName`,
            label: isGarage
                ? formatMessage({
                      id: 'gift_card_form.your_name.label.garage',
                      defaultMessage: 'Your Name'
                  })
                : formatMessage({
                      id: 'gift_card_form.your_name.label.dynamite',
                      defaultMessage: 'Your Name'
                  }),
            type: 'text',
            variant: 'webFloatingField',
            rules: {
                required: isGarage
                    ? formatMessage({
                          id: 'gift_card_form.your_name.required.garage',
                          defaultMessage: 'Enter your name'
                      })
                    : formatMessage({
                          id: 'gift_card_form.your_name.required.dynamite',
                          defaultMessage: 'Enter your name'
                      })
            },
            error: errors[`${prefix}yourName`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        recipientName: {
            name: `${prefix}recipientName`,
            label: formatMessage({
                id: 'gift_card_form.recipient_name.label',
                defaultMessage: "Recipient's Name"
            }),
            type: 'text',
            variant: 'webFloatingField',
            rules: {
                required: isGarage
                    ? formatMessage({
                          id: 'gift_card_form.recipient_name.required.garage',
                          defaultMessage: "Enter the recipient's name"
                      })
                    : formatMessage({
                          id: 'gift_card_form.recipient_name.required.dynamite',
                          defaultMessage: "Enter the recipient's name"
                      })
            },
            error: errors[`${prefix}recipientName`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        recipientEmail: {
            name: `${prefix}recipientEmail`,
            label: formatMessage({
                id: 'gift_card_form.recipient_email.label',
                defaultMessage: "Recipient's Email"
            }),
            type: 'email',
            variant: 'webFloatingField',
            rules: {
                required: isGarage
                    ? formatMessage({
                          id: 'use_giftcard_fields.error.pattern_email.garage',
                          defaultMessage: 'Use a valid email format, like  name@example.com'
                      })
                    : formatMessage({
                          id: 'use_giftcard_fields.error.pattern_email.dynamite',
                          defaultMessage: 'Use a valid email format, like  name@example.com'
                      }),
                pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: isGarage
                        ? formatMessage({
                              id: 'use_giftcard_fields.error.pattern_email.garage',
                              defaultMessage: 'Use a valid email format, like  name@example.com'
                          })
                        : formatMessage({
                              id: 'use_giftcard_fields.error.pattern_email.dynamite',
                              defaultMessage: 'Use a valid email format, like  name@example.com'
                          })
                }
            },
            error: errors[`${prefix}recipientEmail`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        confirmRecipientEmail: {
            name: `${prefix}confirmRecipientEmail`,
            label: formatMessage({
                id: 'gift_card_form.confirm_recipient_email.label',
                defaultMessage: "Confirm Recipient's Email"
            }),
            type: 'email',
            variant: 'webFloatingField',
            rules: {
                required: formatMessage({
                    id: 'gift_card_form.confirm_recipient_email.mismatch',
                    defaultMessage: 'Emails do not match'
                }),
                validate: (value) => {
                    if (value !== recipientEmail) {
                        return formatMessage({
                            id: 'gift_card_form.confirm_recipient_email.mismatch',
                            defaultMessage: 'Emails do not match'
                        })
                    }
                    return true
                }
            },
            error: errors[`${prefix}confirmRecipientEmail`],
            control,
            inputProps: {
                paddingRight: 0,
                maxLength: 50
            }
        },

        message: {
            name: `${prefix}message`,
            label: formatMessage({
                id: 'gift_card_form.message.label',
                defaultMessage: 'Message'
            }),
            secondaryLabel: formatMessage({
                id: 'gift_card_form.message.secondary_label',
                defaultMessage: '(optional)'
            }),
            type: 'textarea',
            variant: 'webFloatingFieldTextArea',
            rules: {},
            error: errors[`${prefix}message`],
            control,
            rows: 4,
            maxLength: 250
        }
    }

    return fields
}
